export default __webpack_public_path__ + "static/mcs-4c5a3e65d251615b730d040481967311.svg";